module.exports = __webpack_public_path__ + "media/images/logo_hercules-fc81f945468444448e60c7bb3c90261f.png";